// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8YrG7","header":"styles_header__BoYW6","headerTitle":"styles_headerTitle__YOX5V","content":"styles_content__Da9jI"};